import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Home.css";
import Box from "./Box.jsx";
import DownloadFile from "../DownloadFile/DownloadFile.jsx";

import fluteImage from "../../assets/Home/jpeg-optimizer_flute.jpeg";
import fluteCampImage from "../../assets/Home/jpeg-optimizer_fluteCamp2.jpg";

const homeHeader = "Welcome to Flute Alliance";
const homeDescription =
  "Flute Alliance is a partnership of professional performing musicians and organizations that come together to offer flute education and performance opportunities to enthusiasts of all ages.  From the highly successful Flute Boot Camps for flutists in 8th-12th grades, to the BreakAway Flutist Vacations designed for flute enthusiasts over 18 years old. There's always a new partnership and opportunity for flutists at Flute Alliance!";
const homeButton = "Join Our Mailing List";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="home-wrapper">
      <Container>
        <Row className="home-empty-row"></Row>
        <Row>
          <Col xs={12} md={6} className="order-md-2">
            <img className="home-flute-camp-img" src={fluteImage} alt="home" />
            <br />
            <br />
          </Col>
          <Col xs={12} md={6} className="order-md-1">
            <Box
              title={homeHeader}
              description={homeDescription}
              button={homeButton}
              onClick={() => navigate("/contact")}
            />
          </Col>
        </Row>

        <br />

        <Row className="home-empty-row">
          <b>
            <h2 className="home-h2 home-announce-top">NEXT UP......</h2>
            <h2 className="home-h2 home-announce-bottom">
              Upcoming Flute Alliance Events:
            </h2>
          </b>
          <hr />
        </Row>

        <Row style={{ fontWeight: "800" }}>
          <h3>Flute Boot Camp 2025 Registration is OPEN!</h3>
          <br />
          <br />
          <Col md={6}>
            <img
              className="home-flute-camp-img"
              src={fluteCampImage}
              alt="Flute Boot Camp 2024"
            />
            <DownloadFile
              fileName="fbc2025_registration.pdf"
              fileUrl="./pdfs/fbc2025_registration.pdf"
            />
          </Col>
          <Col md={6}>
            <div className="home-fbc">
              <div></div>
              <div>
                The premier flute camp in the PNW celebrates its 19th year the
                week of July 7-11. Limited to 25 campers. Come join our top
                coaches, Sydney Carlson, Adam Eccleston and Denise Westby in
                daily large and small ensemble rehearsals, music education
                games, and a solo Master Class! SPECIAL GUEST ZACH GALATIS OF
                THE OREGON SYMPHONY!!
              </div>
              <br />
              <div>
                ​Discount for early registration. ​LINK TO CURRENT REGISTRATION
                FORM.
              </div>
            </div>
          </Col>
        </Row>
        <Row className="home-empty-row"></Row>
      </Container>
    </div>
  );
}
